<template>
  <div class="add-step" style="overflow: scroll">
    <div class="bg-black add-accont-header">
      <div class="add-brd">
        <div class="h-back" @click="goBackHandler">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            stroke-width="2"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M15 19l-7-7 7-7"
            />
          </svg>
        </div>
        <h2>اطلاعات کسب و کار</h2>
        <p>مرحله بعد: اطلاعات فضای مجازی</p>
      </div>
      <div>
        <svg class="header-progresbar2">
          <circle class="meter" cx="57" cy="57" r="42" />
          <circle class="meter-2" cx="57" cy="57" r="42" />
          <text class="SVG-text" x="37" y="47">مرحله</text>
          <text x="65" y="74" class="SVG-text">2</text>
          <text x="50" y="74" class="SVG-text">از</text>
          <text x="37" y="74" class="SVG-text">3</text>
        </svg>
      </div>
    </div>
    <div class="add-card">
      <!-- <p class="head-step2"</p> -->
      <div class="gruop">
        <p>تصویر پس زمینه</p>
        <file-uploder v-model="model.background" size="100px" editable>
        </file-uploder>
      </div>
      <div class="gruop">
        <p>آواتار</p>
        <file-uploder
          v-model="model.avatar"
          size="60px"
          editable
        ></file-uploder>
      </div>

      <div class="gruop">
        <p>بیوگرافی</p>
        <input v-model="model.bio" class="inputName" placeholder="بیوگرافی" />
      </div>
      <div class="gruop">
        <p>شماره تلفن ثابت</p>
        <input
          type="number"
          v-model="model.phone"
          class="inputName main-input"
          placeholder="شماره تلفن ثابت"
        />
        <p class="error" v-if="this.phone != nulll && this.err">
          شماره تلفن خودرا کامل با حد اقل 10 رقم وارد کنید
        </p>
      </div>
      <div class="gruop">
        <p>شماره تلفن همراه</p>
        <input
          type="number"
          v-model="model.mobile"
          class="inputName main-input"
          placeholder="شماره تلفن همراه"
        />
        <p class="error" v-if="this.mobile != nulll && this.err">
          شماره تلفن همراه خودرا کامل با حد اقل 11 رقم وارد کنید
        </p>
      </div>
      <div class="gruop">
        <p>آدرس:</p>
        <input v-model="model.address" class="inputName" placeholder="آدرس" />
      </div>

      <button class="m-btn add-confer-btn" @click="checkErrHandler">
        تایید
      </button>
    </div>
  </div>
</template>

<script>
import fileUploder from "@/components/FileUploader.vue";
export default {
  components: {
    fileUploder,
  },
  mounted() {
    this.getSetting();
  },
  data() {
    return {
      err: false,
      creatModel: {},
      avatarUrl: "",
      mainAcc: false,
      avatar: null,
      model: {},
    };
  },
  methods: {
    goBackHandler() {
      this.$router.back();
    },
    getSetting() {},
    checkErrHandler() {
      this.err = false;
      if (
        this.model.mobile != null &&
        this.model.mobile.toString().length < 11
      ) {
        this.err = true;
      } else if (
        this.model.phone != null &&
        this.model.phone.toString().length < 10
      ) {
        this.err = true;
      } else {
        this.goNextHandler();
      }
    },
    goNextHandler() {
      if (!this.err) {
        this.model.name = this.$store.state.businessaccount.name;
        this.model.account = this.$store.state.businessaccount.account;
        this.model.category = this.$store.state.businessaccount.accountCategory;
        this.model.business_id = this.$store.state.businessaccount.business_id;
        this.$store.commit("businessaccount/setModel", this.model);
        this.$emit("next");
      }
    },
  },
};
</script>

<style scoped>
.head-step2 {
  margin-top: 50px;
  font-size: 20px;
}
.add-card {
  direction: rtl;
}
.gruop p {
  text-align: right;
}

.gruop input {
  width: 80%;
}
p.error {
  color: red;
  margin-right: 25px;
}
</style>
